import React from 'react';
import SkillIcon from './SkillIcon';

const FrontendData = [
   { id: 1,  name: 'Kotlin' },
   { id: 2,  name: 'Java' },
   { id: 3,  name: 'C++' },
   { id: 4,  name: 'C' },
   { id: 5,  name: 'Go' },
   { id: 6,  name: 'XML' },
   { id: 7,  name: 'Android SDK' },
   { id: 8,  name: 'Android Studio' },
   { id: 9,  name: 'AdMob' },
];

const FrontendSkill = () => (
   <>
      {FrontendData.map(({ id, name }) => (
         <div key={id} className="skill-card group">
            <SkillIcon name={name} className="skill-icon" />
            <p className="skill-name">{name}</p>
         </div>
      ))}
   </>
);

export default FrontendSkill;

